/**
 * @deprecated This function is deprecated. Use an `ISOString` method for UTC date handling.
 */
const getUTCDate = (date: Date = new Date()): Date => new Date(date.getTime() + (date.getTimezoneOffset() * 60 * 1000));

export default getUTCDate;
